import React from 'react';

import ChromeLogo from './images/chrome.svg';
import FireFoxLogo from './images/firefox.svg';
import OperaLogo from './images/opera.svg';
import YandexLogo from './images/yandex.svg';
import EdgeLogo from './images/edge.svg';

const config = [
    {
        id: 1,
        title: 'Mozilla Firefox',
        link: 'https://addons.mozilla.org/en-US/firefox/addon/epn-webmaster-plugin/',
        icon: FireFoxLogo,
    },
    {
        id: 2,
        title: 'Chrome',
        link:
            'https://chrome.google.com/webstore/detail/epn-webmaster-plugin/jeaompkpfafalmlchhmehhfhmojmmkol',
        icon: ChromeLogo,
    },
    {
        id: 4,
        title: 'Opera',
        link:
            'https://chrome.google.com/webstore/detail/epn-webmaster-plugin/jeaompkpfafalmlchhmehhfhmojmmkol',
        icon: OperaLogo,
    },
    {
        id: 5,
        title: 'Yandex.Browser',
        link:
            'https://chrome.google.com/webstore/detail/epn-webmaster-plugin/jeaompkpfafalmlchhmehhfhmojmmkol',
        icon: YandexLogo,
    },
    {
        id: 6,
        title: 'Microsoft Edge',
        link:
            'https://chrome.google.com/webstore/detail/epn-webmaster-plugin/jeaompkpfafalmlchhmehhfhmojmmkol',
        icon: EdgeLogo,
    },
];

const Browsers: React.FC = () => (
    <div className="flex flex-row flex-wrap items-center justify-start">
        {config.map(item => {
            return (
                <a
                    key={item.id}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center p-5 mb-4 mr-4 bg-blueGray-100 rounded-3"
                    style={{
                        minWidth: '160px',
                    }}
                >
                    <img className="w-20 h-20 mb-2.5" src={item.icon} alt={item.title} />
                    <p className="text-black">{item.title}</p>
                </a>
            );
        })}
    </div>
);

export default Browsers;
